import type { UserState } from '../../powershadesApiTypeExtensions';
import { loadStatus } from '../entities/entitiesType';

export const initialUserState: UserState = {
	id: 0,
	loading: false,
	name: '',
	email: '',
	roles: [],
	authenticated: false,
	error: '',
	jwt: '',
	refreshJwt: '',
	is_sales_person: false,
	is_disallowed_force_edit: false,
	is_engineering: false,
	is_service: false,
	is_manufacturing: false,
	is_using_old_homepage: false,
	is_allowed_parts_on_cedia: false,
	cta_popup_dismissed_version: '0',
	theme: 'light',
	links: {
		loadStatus: loadStatus.needsLoaded,
		list: []
	}
};
